export const BrushTypes = [
    'PencilBrush',
    'VLineBrush',
    'HLineBrush',
    'CircleBrush',
    'SquareBrush',
    'SprayBrush',
];

export const BrushSizes = [1, 8, 15, 20, 25];
